import { MandateStatus } from '@shared/types/mandate-state.type';

export const STATUS_COLORS_PALETTE: {
  [key in MandateStatus]: [string, string];
} = {
  ['pending confirmation']: ['#EAB300', '#23344B'],
  ['confirmed']: ['#1C78CE', '#FFFFFF'],
  ['pending signature']: ['#23344B', '#FFFFFF'],
  ['signed']: ['#228619', '#FFFFFF'],
  ['refused']: ['#A91E2C', '#FFFFFF'],
};
